import { database, storage } from '../config';
import ErrorLog from './error';
const Error = new ErrorLog()

export default class Archivo {
    constructor() {
        this.Descripcion = ''
        this.Fecha = new Date()
        this.Link = ''
    }
    getArchivos() {
        return new Promise((resolve, reject) => {
            database.collection("archivos")
                .get()
                .then(querySnapshot => resolve(querySnapshot.docs))
                .catch(error => reject(Error.guardarError(error)))
        })
    }

    guardar(archivo) {
        return new Promise((resolve, reject) => {
            database.collection('archivos')
                .doc()
                .set({
                    ...archivo,
                })
                .then(result => resolve(result))
                .catch(error => reject(Error.guardarError(error)))
        })

    }

    guardarFile(file, descripcion, actualizarImgProgress) {
        const refStorage = storage.ref(`Archivos/${descripcion}`)
        const task = refStorage.put(file)
        return new Promise((resolve, reject) => {
            task.on('state_changed',
                snapshot => {
                    const porcentaje = snapshot.bytesTransferred / snapshot.totalBytes * 100
                    actualizarImgProgress(porcentaje)
                },
                err => {
                    reject(Error.guardarError(err))
                },
                () => {
                    task.snapshot.ref.getDownloadURL()
                        .then(url => {
                            resolve(url)
                        })
                        .catch(err => reject(Error.guardarError(err)))
                })
        })
    }

    eliminar(id) {
        console.log(id)
        return new Promise((resolve, reject) => {
            database.collection("archivos")
                .doc(id)
                .delete()
                .then(result => resolve(result))
                .catch(error => reject(Error.guardarError(error)))
        })
    }

    eliminarFile(descripcion) {
        const refStorage = storage.ref(`Archivos/${descripcion}`)
        return new Promise((resolve, reject) => {
            refStorage.delete()
                .then(resolve('Archivo eliminado'))
                .catch(error => reject(Error.guardarError(error)))
        })
    }


}